export default "__VITE_ASSET__N1Bx_EV8__"